export const pt = {
  ADD_COLOR_STRING_KEY: 'Add color',
  ADD_TEXT_KEY: 'Adicionar texto',
  ADD_TO_ORDER_KEY: 'Add to order',
  ADD_TO_CART: 'Adicionar ao carrinho',
  ADD_TEMPLATE: 'Add Template',
  ADJUST_SIZE_KEY: 'Adjust Size',
  ADJUST_TRANSPARENCY_KEY: 'Adjust Transparency',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "By clicking Done, you agree to the HP's terms of use and privacy statement.",
  ALIGN_BOTTOM_KEY: 'Alinhar o fundo',
  ALIGN_CENTER_KEY: 'alinhar centro',
  ALIGN_KEY: 'alinhar',
  ALIGN_LEFT_KEY: 'Align Left',
  ALIGN_MIDDLE_KEY: 'alinhar o meio',
  ALIGN_RIGHT_KEY: 'Align Right',
  ALIGN_TOP_KEY: 'Alinhar o topo',
  ALL_TAB_TITLE_KEY: 'Tudo',
  ALMOST_DONE_TITLE_KEY: 'Almost done!',
  AND_KEY: 'and',
  APPLY_KEY: 'Apply',
  AREA_CODE: 'Area code',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'Browse the content and select the images for your design, or upload your own',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Preview your design, or fine-tune the details',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Customize the design and add other elements to your project',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'When the design is ready, click NEXT to make a final check and place your order.',
  BACK_KEY: 'Back',
  BACKGROUND_KEY: 'Plano de fundo',
  BACKGROUND_UPPER_CASE_KEY: 'BACKGROUND',
  BACKGROUND_CONTRAST_KEY: 'Background Contrast',
  BLANK_INSPIRATION_CATEGORY_KEY:
    'Nenhuma inspiração encontrada nesta categoria',
  BRING_TO_FRONT_KEY: 'Trazer para a frente',
  CANCEL_TEXT_KEY: ' Cancelar ',
  CENTIMETERS_KEY: 'centímetros',
  CM_KEY: 'cm.',
  CHANGE_YOUR_SETTINGS_KEY: 'Change your project settings',
  CHECKBOX_CONTENT1: 'I want to receive the Pattern Design© newsletter',
  CHECKBOX_CONTENT2:
    'I authorize HP to create an account in Pattern Design© services on my behalf',
  CHOOSE_FROM_COMPUTER_KEY: 'Choose from computer',
  CHOOSE_RIP_OPTIONS: 'Choose one of these compatible third party RIPs',
  CHOOSE_FILE_KEY: 'Escolha o arquivo',
  CITY: 'City',
  CLEAR_ALL_KEY: 'Limpar tudo',
  CLEAR_COLOR_KEY: 'Limpar cores',
  CLOSE_WINDOW_KEY: 'Fechar janela',
  CLEAR_ALL_OBJECTS: 'Limpar todos os objetos',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'Isso removerá todos os objetos do plano de fundo.',
  CLEAR_DESIGN_KEY: 'Clear design',
  COLOR_KEY: 'Colorido',
  CONTINUE_KEY: 'Continuar...',
  COMPANY: 'Company',
  CONGRATULATIONS_KEY: 'Congratulations!',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PATTERN_ACCOUNT_KEY: "Don't have a Pattern Design account yet?",
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Don't have a Vecteezy account yet?",
  COUNTRY: 'Country',
  CREATE_ACCOUNT: 'Create account',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Custom',
  CUSTOM_PRICE_SIGN_IN_KEY: 'Sign-in in the next step to see custom pricing.',
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: 'Create new',
  DESIGN_KEY: 'Projeto',
  DELETE_KEY: 'Excluir',
  DOCUMENT_COLORS: 'Cores do Documento',
  DONE: 'Done!',
  DONE_KEY: 'Concluído',
  DONT_SHOW_ALERT_KEY: "Don't show again",
  DOWNLOAD_COLUMN_HEADER_KEY: 'Download',
  DOWNLOAD_APP_TITLE_KEY: 'Você pode baixar o aplicativo aqui:',
  DOWNLOAD_LINK_KEY: 'Download HP Click for free here',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DOWNLOAD_INSTR_KEY: 'Make sure you have HP Click installed before continuing',
  DOWNLOAD_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Importação do Dropbox',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'The image size should be less than 1 GB. We accept pdf, png, jpg, svg and tiff formats.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Pesquisa de Dreamstime',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Imagens de Dreamstime',
  DUPLICATE_KEY: 'Duplicar',
  EACH_ITEM_PRICE_KEY:
    'Your design includes content from one of our premium content providers. The itemized pricing of each element is summarized below.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Editar projeto',
  EDIT_LOWERCASE_KEY: 'edit',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT: 'Erro. Tente mais tarde.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'Ops, houve um erro na abertura do arquivo PDF carregado.',
  EMAIL_KEY: 'E-mail',
  EMAIL_ADDRESS_KEY: 'Endereço de e-mail:',
  EMAIL_CHECKBOX_MESSAGE:
    'Sei que essa pessoa está ciente de que receberá e-mails da HP em meu nome ou ou do prestador de serviços.',
  EXTRA_INFO_KEY: 'Informações extras',
  EMAIL_NOTIFICATION:
    'Um e-mail será enviado em breve. Aguarde até 15 minutos para o processamento.',
  EMAIL_DIALOG_MESSAGE:
    'Digite o e-mail da pessoa com a qual deseja compartilhar o projeto.',
  ENTER_KEY: 'Enter',
  EXISTING_FOLDER_KEY: 'Pasta existente',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'Certifique-se de que todos os itens selecionados estejam corretos antes de seguir para o caixa',
  FINAL_CHECK_TITLE_KEY: 'Verificação final',
  FINISH_KEY: 'Terminar',
  FINISH_LATER_KEY: 'Finish later',
  FIRSTNAME: 'First name',
  FISCAL_NUM: 'Fiscal number',
  FLIP_KEY: 'Inverter',
  FOR_KEY: 'para',
  FORGOT_PASSWORD_KEY: 'Forgot password?',
  FOTOLIA_KEYWORDS_KEY: 'Palavras-chave:',
  FOLDER_NAME: 'Nome da pasta',
  FOLDER_NAME_KEY: 'Nome da pasta:',
  FOLDER_ALREADY_EXIST_KEY: 'Já existe uma pasta com esse nome',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    "You've just completed your free poster design",
  FREE_VECTOR_GRAPHICS_KEY: 'free vector graphics',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'Ok, I got it',
  GROUP_ALL_KEY: 'Agrupar tudo',
  GROUP_SCALE: 'Escala de grupo',
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: 'Dê um nome ao projeto',
  HEIGHT_KEY: 'Altura',
  HELP_KEY: 'Ajuda',
  HELPER_TITLE_KEY_1:
    'Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media',
  HELPER_TITLE_KEY_3: 'See all your design work in one place',
  HELPER_TITLE_KEY_4: 'Click Next to preview and finish your final design',
  HERE_KEY: 'here',
  HELP_IMPROVE_KEY:
    'Help improve your productivity and operator efficiency, and expand with color production.',
  HIGH_QUALITY_KEY: 'High-quality',
  IMAGES_TITLE_KEY: 'IMAGENS',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: 'Importando',
  INCHES_COLUMN_HEADER_KEY: 'Polegadas',
  INCHES_KEY: ' polegadas',
  INCHES_UNIT_STRING_KEY: 'pol.',
  INVALID_EMAIL_ADDRESS_KEY: 'Endereço de e-mail inválido',
  INVALID_INFO_KEY: 'Please enter details.',
  INVALID_NAME_KEY: 'Nome inválido',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'O arquivo selecionado é muito grande. O tamanho máximo de arquivo é 500 MB.',
  INSUFFICIENT_CREDITS_KEY: 'Insufficient credits',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'Ops, formato inválido! Só aceitamos pdf, jpg, png, svg e tif.',
  LANDSCAPE_KEY: 'Landscape',
  LANGUAGE_LABLE_KEY: 'Idioma',
  LASTNAME: 'Last name',
  LEARN_MORE: 'Saiba mais',
  LEARN_THE_BASICS_KEY: 'Learn the basics',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'Ao usar este aplicativo, você concorda em estar vinculado a estes termos',
  LEGAL_FOOTER_MESSAGE2_KEY: 'Este site está em conformidade com',
  LEGAL_FOOTER_MESSAGE3_KEY: 'e o',
  LENGTH_STRING_IN_INCHES_KEY: 'pol.',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'change',
  LINK_READER_APP_KEY: 'LinkReader App',
  LINK_READER_APP_DESCRIPTION_KEY:
    'Para visualizar o conteúdo que está adicionando, baixe o aplicativo LinkReader.',
  LOADING_KEY: 'Carregando...',

  LOADING_TEMPLATE_KEY: 'Loading template',
  LOGIN_NOW: 'Login now',
  LOCK_KEY: 'Vincular',
  LOGIN_KEY: 'Fazer login',
  LOGIN_PATTERN_DESIGN_KEY: 'Login to Pattern design',
  LOGIN_SUBTITLE_KEY: 'Login to see customized pricing and payment details',
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'Login para Dreamstime',
  LOGOUT_KEY: 'Sair',
  MATERIAL_TITLE_KEY: 'MATERIAL',
  MATERIAL_STRING_KEY: 'Material',
  MEASUREMENT_KEY: 'Measurement',
  METRIC_KEY: 'Metric',
  MINIMUM_ZOOM_WARNING:
    'O plano de fundo não pode ser dimensionado além do limite mínimo de altura ou largura necessário para cobrir a parede.',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'Modelo',
  MORE_INFO_TEXT_KEY: 'Mais informações',
  MY_GIFTWRAPS_KEY: 'My Gift Wraps',
  MY_WORK_KEY: 'My work',
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  NAME_KEY: 'Nome:',
  NEXT_BUTTON_TITLE_KEY: 'PRÓXIMO',
  NEW_FOLDER_KEY: 'Nova pasta',
  NO_SHADOW_KEY: 'Sem sombra',
  OBJECT_QUANTITY_KEY: 'Quantity',
  OBJECTS_UPPER_CASE_KEY: 'OBJECTS',
  OK_KEY: 'OK',
  ORDER_SAMPLE_KEY: 'Amostra de pedido',
  ORDER_SAMPLE: 'Pedir uma amostra',
  ORDER_SAMPLE_INFOLABEL_1:
    'Selecione a parte da imagem que deseja solicitar como amostra',
  ORDER_SAMPLE_INFOLABEL_2:
    'Você receberá um email com uma visão detalhada de seu projeto no tamanho real',
  ORDER_SAMPLE_INFOLABEL_3:
    'Isso o ajudará a avaliar a qualidade e a resolução',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'Solicitar amostra agora',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'Receba um e-mail contendo uma visão aproximada de seu projeto com tamanho real para avaliar a qualidade/resolução.',
  ORIENTATION_KEY: 'Orientation',
  OTHER_PRINTING_OPTIONS: 'Other printing options',
  PASSWORD_KEY: 'Senha',
  PATTERN_COLOR_KEY: 'Pattern Color',
  PATTERN_DESIGN_TITLE_KEY: 'Projeto de padrão',
  PATTERNS_FOR_KEY: 'patterns for',
  PDF_GENERATION_ERROR_MESSAGE_KEY: 'Failed to generate pdf. Please try again.',
  PHOTOS_KEY: 'PHOTOS',
  PHOTO: 'photo',
  PHONE: 'Phone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'Eu detenho o copyright desta imagem e concordo com',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'The image size should be less than 500 MB. We accept png, jpg, tiff, svg and pdf formats.',
  PIXEL_COLUMN_HEADER_KEY: 'Pixel',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Enter text here...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'isto é, algumas informações importantes que você precisa comunicar à gráfica',
  PLACEHOLDER_INCHES_STRING_KEY: 'pol.',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'My Poster',
  PORTRAIT_KEY: 'Portrait',
  POSITION: 'Posição',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium images:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Salve seu projeto',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'Seu projeto tem alterações que precisam ser salvas para que você possa continuar.',
  PRICE_COLUMN_HEADER_KEY: 'Preço',
  PRINTER_SERIAL_NUMBER_KEY: 'Printer serial number*',
  PRINTING_ENABLE_DETAILS_KEY:
    'To enable printing we just need a few more details',
  PRINTER_MODELS_KEY: 'Printer models*',
  PROCESSING_KEY: 'Processando...',
  PROCESSING_ALERT_TXT:
    'Do not close this window while we are processing your design',
  PROCESSING_ALERT_TXT2:
    'Once processing has been completed, HP Click will open automatically and start downloading your file',
  PROCESSING_DONE: 'You are almost done!',
  PROCESSING_FILE_TXT: 'Your file is being processed.',
  PROCESSING_TIME_TXT:
    'This may take some time as we are composing your creation to ensure the best image quality',
  PROCESSING_ALERT_TXT3:
    'Your PDF will be automatically downloaded to your computer',
  PROCESSING_ALERT_TXT4:
    'Remember you can configure your JDF connection for automation in settings',
  PREMIUM_CONTENT_KEY: 'Premium Content',
  PREVIEW_KEY: 'Visualizar',
  PROFESSIONAL_USE_TITLE_KEY: 'professional use.',
  PROJECT_NAME_KEY: 'Nome do projeto',
  PROJECT_NAME: 'Nome do projeto:',
  PROJECT_ALREADY_EXIST_KEY: 'Já existe um projeto com esse nome',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'Já existe um projeto com esse nome',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'Já existe uma pasta com esse nome',
  PIXELATION_WARNING_KEY: 'Aviso de pixelização',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'Devido à resolução da foto enviada, sua pele pode ficar distorcida ou distorcida. Para garantir que não haja desfoque, carregue uma imagem de boa qualidade e evite esticar a imagem. Se você estiver satisfeito com a visualização e quiser continuar, continue enviando.',
  REGISTER_CONTACTINFO: 'Contact information',
  REGISTER_INFO: 'Register information',
  REGISTER_PATTERNSUB1: 'As a value HP customer,',
  REQUIRED_FIELDS_KEY: '*Required fields',
  REQUIRED_FIELDS_TEXT_KEY: 'Required fields',
  REQUIRED_STRING_KEY: 'OBRIGATÓRIO',
  RECOLOR_KEY: 'Recolorir',
  RADICALLY_SIMPLE_KEY: 'Radically simple printing software',
  RIPSELECTION_HEAD:
    'This is your first time, select your prefered compatible printing software',
  RIPSELECTION_DESC:
    'Your selection will become your default printing option path for future print outs. Changes can be made later in settings',
  REGISTER_COMPANYINFO: 'Company information',
  REGISTER_KEY: 'Register',
  REGISTER_NOW: 'Register now',
  REOLOR_KEY: 'Recolorir',
  REQUEST_SAMPLE_KEY: 'Solicitar uma amostra',
  RESIZE_KEY: 'Resize',
  RESIZE_ARBITRARILY_KEY: 'Resize Arbitrarily',
  RESIZE_PROPORTIONALLY_KEY: 'Resize Proportionally',
  REVIEW_AND_SUBMIT_KEY: 'Review and Submit',
  REQUEST_FOR_QUOTATION: 'Solicitação de cotação',
  RIGHT_LOGO_TEXT_KEY: 'por',
  ROTATE_KEY: 'Girar',
  ROTATE_LEFT_KEY: 'Girar 90° para a esquerda',
  ROTATE_RIGHT_KEY: 'Girar 90° para a direita',
  ROTATION_KEY: 'Giro',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Linhas e colunas',
  ROYALTY_FREE_KEY: 'royalty-free',
  ROYALTY_KEY: 'royalty',
  SALUTATION: 'Salutation',
  SAVE_KEY: 'Salvar',
  SAVING_KEY: 'Salvando...',
  SAVE_INSPIRATION: 'Save inspiration',
  SAVE_TEMPLATE: 'Save template',
  SAVE_DIALOG_TITLE: 'Salve seu projeto',
  SAVE_PROJECT_NAME_KEY: 'Salvar seu projeto primeiro',
  SAVEDIALOG_MESSAGE:
    'Faça login para salvar o projeto. Se você não tiver uma conta, vamos ajudá-lo a criar uma. Seu progresso não será perdido.',
  SEAMLESS_KEY: 'seamless',
  SCALE_INFO_STRING_KEY: 'Scale the image to fit with on your design',
  SCALE_KEY: 'Dimensionar',
  SCALE_ALL_KEY: 'Dimensionar tudo',
  SCALE_TO_FILL_KEY: 'Scale To Fill',
  SEARCH_BUTTON_TITLE_KEY: 'Pesquisar',
  SELECT_CUSTOM_SIZE_KEY: 'Select custom size',
  SELECT_CUSTOM_KEY: 'Custom',
  SEARCH_TITLE: 'Pesquisar',
  SELECTED_IMAGE_KEY: ' Selected Image: ',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Select Gift Wraps size',
  SELECT_COUNTRY: 'Select Country',
  SELECT_SALUTATION: '---Select---',
  SELECT_POSTER_SIZE_KEY: 'Select poster size',
  SELECT_PRINTING_OPTION_KEY: 'Select your prefered printing option',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'Envie-me instruções de instalação',
  SEND_TO_BACK_KEY: 'Enviar para trás',
  SEND_KEY: 'Enviar',
  SEND_TO_PRINT_TITLE_KEY: 'Send to print',
  SET_SIZE_KEY: 'Definir tamanho',
  SETTINGS_KEY: 'Configurações',
  SETTINGS_UPPERCASE_KEY: 'SETTINGS',
  SHARE_KEY: 'Compartilhar',
  SIGNED_IN_AS_KEY: 'Signed in as',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Sign in or register to see customized pricing and payment details',
  SIGN_UP_NOW_KEY: 'Sign up now',
  SKIP_KEY: 'Skip',
  SOLID_COLORS_KEY: 'Solid Colors',
  SQFT_UNIT_STRING_KEY: 'pés quad.',
  SQM_UNIT_STRING_KEY: 'm quad.',
  START_TOUR_KEY: 'Start tour',
  STATUS_MSG: 'Your file has been sent to print!',
  SUBMIT_BUTTON_KEY: 'Enviar',
  SHARE_LINK_LABEL: 'Escolha o tipo de link que quer compartilhar',
  SHARE_EDIT_LINK: 'Editar link',
  SHARE_VIEW_LINK: 'Visualizar link',
  SHARE_YOUR_CREATION: 'Share your creation!',
  STREET_ADD: 'Street address',
  TARGET_VIEWING_HINT:
    '* A distância de visualização de destino pode ser alterada nas configurações.',
  TERMS1_KEY: 'termos',
  TERMS2_KEY: 'Declaração de privacidade da HP',
  TERMS3_KEY: 'Aviso de direitos sobre dados pessoais da HP',
  TERMS_OF_USE_KEY: 'Terms of use',
  TERMS_OF_USE: 'Termos de uso.',
  TEXT_ANCHOR_MIDDLE: 'Center',
  TEXT_SHADOW_COLOR_KEY: 'Text shadow Color',
  TEXT_UPPERCASE_KEY: 'TEXT',
  TILE_KEY: 'Bloco',
  TOTAL_KEY: 'TOTAL',
  TOTAL_PRICE_KEY: 'Total:',
  TRANSPARENCY_KEY: 'Transparency',
  TEMPLATES_KEY: 'templates',
  TEMPLATES_UPPER_CASE_KEY: 'TEMPLATES',
  THANK_YOU_KEY: 'Obrigado',
  TOUR_DESCRIPTION_TEXT:
    'Let us walk you through the design process. Remember you can re-open the tour at any time by clicking on the help icon.',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'Desvincular',
  UNGROUP_KEY: 'Desagrupar',
  UPDATE_TEXT_KEY: 'Atualizar',
  UPLOAD_KEY: 'Upload de imagens',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Upload your own image',
  UPLOAD_UPPERCASE_KEY: 'UPLOAD',
  USER_NAME: 'Nome de usuário',
  USER_TYPE_TITLE_KEY: 'What type of user are you*',
  UNTILE_KEY: 'Desfazer bloco',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Search',
  VALIDITY_KEY: 'Validade',
  VANILLA_LOGIN_DIALOG_KEY:
    'Join for free to save and print your design and see your saved work',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'This is the preview of your design, check the design is final before proceeding or select edit to make any changes',
  VAT_KEY: 'VAT',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vector',
  VIEW_FOTOLIA_KEY: 'Exibir no Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'Exibir detalhes do projeto',
  VIEW_DESIGNER_PROFILE_KEY: 'Exibir perfil do projetista',
  VIEW_PRICE_KEY: 'Exibir preço',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',
  WALL_POSTER_KEY: 'Pôster de parede',
  WALL_SIZE_TEXT_KEY: 'Wall size',
  WARNING_KEY: 'Aviso',
  WEBSITE: 'Website',
  WIDTH_KEY: 'Largura',

  YOU_CAN_ALWAYS_ACCESS: 'You can always access your designs in ',
  YOUR_NAME_KEY: 'Seu nome',
  YOUR_SELECTION_WILL_KEY:
    'Your selection will become your default printing path for future print outs.',
  YOUR_PROJECT_KEY: 'Seu projeto',
  PROJECT_NAME_ERROR_TEXT: 'Informe um nome para o projeto.',
  PROJECT_FOLDER_ERROR_TEXT: 'Informe um nome para a pasta do projeto.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixel warning settings',
  MINIMUM_VIEWING_DISTANCE_KEY: 'Distância mínima de visualização',
  BACKGROUND_UPLOAD_KEY: ' background ',
  OBJECT_UPLOAD_KEY: ' object ',
  PHOTO_UPLOAD_KEY: ' photo ',
  NO_DREAMSTIME_ERROR_MESSAGE: 'Nenhum conteúdo encontrado',
  NO_ELEMENT_ERROR_MESSAGE: 'Nenhum elemento encontrado.',
  NO_MORE_IMAGES_FOUND_KEY: 'Não foram encontradas mais imagens',
  NO_PATTERN_ERROR_MESSAGE: 'Nenhum padrão foi encontrado.',
  ALREDY_HAVE_AN_ACCOUNT: 'Already have a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Change to {0}',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Hex color: {0}',
  NEAR_KEY: 'Near',
  FAR_KEY: 'Far',
  CLOSE_UP_KEY: 'Close Up',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'The images you are trying to use are either smaller or larger than the design area you are using.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'To get better results use a {0} X {1} resolution image',
  MESSAGE_KEY: 'Mensagem:',
  VIEWS_KEY: '{0} views',
  COST_DESCRIPTION_MESSAGE_KEY:
    'This is the summary of the cost related to the premium content included in your design. {0} By selecting finish you agree to be charged the following cost by the content providers.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} is your default printing option,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' you will revieve $100 worth of high-resolution images {0} to help with all your creative needs!',
  REGISTER_PATTERNSUB3:
    'Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs.',
  ZOOM_WARNING_PIXELATED_TEXT:
    'Você dimensionou ao ponto da imagem impressa parecer pixelada quando visualizada a {0} {1} * (a resolução atual de impressão é {2} dpi).',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'A distância recomendada para visualização seria {0} {1}. Caso a distância não seja apropriada, reduza a escala da imagem ou o tamanho da arte da parede.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'O tamanho mínimo recomendado para imagens é de {0} x {1} pixels.',
  UPLOAD_STATUS: '{0}% de {1}MB',
  REGISTER_TO: 'Register to {0}',
  MINIMUM_DIMENSIONS_KEY: 'As dimensões máximas são {0} (l) by {1} (a).',
  MINIMUM_HEIGHT_KEY: 'A altura mínima é {0}.',
  MINIMUM_WIDTH_KEY: 'A largura mínima é {0}.',
  MAXIMUM_DIMENSIONS_KEY: 'Maximum dimensions are {0} (w) by {1} (h).',
  MAXIMUM_WIDTH_KEY: 'A largura máxima é {0}',
  MAXIMUM_HEIGHT_KEY: 'A altura máxima é {0}.',
  INVALID_NUMBER_ERROR_TEXT_KEY:
    'Informe dimensões numéricas maiores que zero.',
  PROCESSING_FAILED: 'Falha no processamento, tente mais tarde',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT: 'Não há suporte a PDFs com várias páginas.',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT:
    'Desculpe, PDFs criptografados não são suportados.',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'Importando arquivo {0} de {1}',
  RECOLORING_KEY: 'Recolorindo...',
  TEXT_COLOR_KEY: 'Text Color',
  SOLID_COLOR_KEY: 'Solid Color',
  AUTHENTICATE_DIALOG_TITLE: 'Esta fonte de conteúdo é protegida por senha',
  AUTHENTICATE_FAILED_MESSAGE: 'Falha na autenticação!',
  DROPBOX_IMPORT_ERROR_HEADER:
    'Houve um problema na importação de alguns arquivos',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'Project',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'Este modelo do Inspiration vem com um tamanho padrão de {0} X {1} {2}. O tamanho da página será alterado automaticamente para caber neste modelo.',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Choose your laptop',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'First name',
  LAST_NAME_KEY: 'Last name',
  PHONE_NUMBER_KEY: 'Phone No.',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Invalid phone number',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'I accept the terms and conditions.',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'I accept that my personal information will be shared with HP to be contacted about future HP campaigns. *',
  SERVICE_PROVIDER_CONDITION:
    'I accept that the data I provide may be shared with service providers for the purposes of printing and delivery process.',
  ORDER_DESIGN: 'Order design',
  SUBMIT_YOUR_DESIGN: 'Submit your design',
  SUBMISSION_DESIGN_ORDER: 'Submission for design order',
  ENTER_REQUIRED_FIELDS_KEY: 'Por favor, insira campos obrigatórios',
  ADDRESS_KEY: 'Address',
  INVALID_ADDRESS_KEY: 'Invalid address',
  CITY_KEY: 'City',
  INVALID_CITY_KEY: 'Invalid city',
  COUNTRY_KEY: 'Country',
  STATE_KEY: 'State',
  ZIP_KEY: 'Zip',
  INVALID_ZIP_KEY: 'Invalid zip code',
  ORDER_NUMBER: 'Order number',
  YOUR_DETAILS_KEY: 'Seus detalhes',
  APPLY_DESIGN_COMPETITION: 'Apply for the design competition',
  NOTICE_KEY: 'Aviso prévio:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'Para ter uma capa de PC perfeitamente adaptada à sua, você deve selecionar o modelo exato correspondente à compra, como é visto na fatura.',
  RESTART_PROJECT_ALERT_TITLE: 'Restart a project ?',
  DISCARD_ALERT_MESSAGE: 'Your current project will be discarded',
  RESTART: 'Restart',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'Tamanho da página Aviso!',
  MODIFY_SIZE_WARNING:
    'Se você deseja redimensionar esse design, pode fazê-lo na guia "Configurações". Os elementos de design podem exigir edição para se ajustar às dimensões desejadas.',
  RANDOMIZE_KEY: 'Aleatório',
  MATERIAL_CHOICE_APPLIED: 'Escolha do material aplicada.',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: 'certificado de',
  AUTHENTICITY_STRING: 'autenticidade',
  PLEASE_WAIT: 'Por favor, espere',
  PROTECTING_YOUR_DATA: 'protegendo seus dados...',
  SEARCH_YOUR_LAPTOP_KEY: 'Pesquise no seu laptop', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'Opa! Não foi possível encontrar nenhum laptop para sua pesquisa.', // Google translated

  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  SERIAL_NUMBER_KEY: 'Número de série',
  LOCKED_PROJECT: 'Projeto bloqueado',
  LOCKED_MESSAGE:
    'O projeto já foi pedido e não pode ser alterado. Você só pode visualizá-lo.',
  EXPIRED_PROJECT: 'Projeto expirado',
  EXPIRED_MESSAGE: 'Este projeto expirou.',
  DELETED_PROJECT: 'Projeto excluído',
  DELETED_MESSAGE: 'Este projeto foi excluído.',
  CHOOSE_GROUP_TYPE: 'Escolha o tipo {0}',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Informe números maiores que zero.',
  SIZE_KEY: 'Tamanho',
  DISTANCE_FROM_KEY: 'Distância de',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: 'Furniture',
  FIXTURES_KEY: 'Fixtures',
  ADD_A_WALL_KEY: 'Add a wall',
  SELECT_A_WALL_KEY: 'Select a Wall',
  LEFT_KEY: 'Esquerda',
  RIGHT_KEY: 'Direita',
  DELETE_WALL_KEY: 'Delete a wall',

  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Choose canvas type',
  MAXIMUM_WALL_SIZE_KEY: 'O tamanho máximo da parede é {0} {1} quad.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY:
    'A altura da tela excede a altura da parede.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY:
    'A largura da tela excede a largura da parede.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'O máximo de colunas para a largura atual é de {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    'O máximo de linhas para a altura atual é de {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'A largura da parede é inferior à largura da tela.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY:
    'A largura mínima da parede deve ser {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY:
    'A altura mínima da parede deve ser {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'A altura da parede é inferior à altura da tela.',
  MAXIMUM_WALL_HEIGHT_KEY: 'A altura máxima da parede é {0} {1}.',
  FINISHING_KEY: 'Finishing',
  MIRROR_KEY: 'Mirror',
  NATURAL_KEY: 'Natural',
  ROWS_KEY: 'Linhas',
  COLUMNS_KEY: 'Colunas',
  DEFAULT_WALL_SIZE_KEY: 'Default Wall Size',
  EDIT_KEY: 'Editar',
  TOP_KEY: 'Topo',
  BOTTOM_KEY: 'Fundo'
};
